import React from 'react'
import { Box } from '@mui/material'
import { modelTypeToMarkerProps, isRackType } from '../../../helpers'

const DeviceIcon = ({ type, device, size = 24 }) => {
  const markerProps = modelTypeToMarkerProps({ 
    type: type || device?.model?.type, 
    available_level: device?.available_level
  })
  
  const isRack = isRackType(type || device?.model?.type)
  
  const colors = markerProps.colors || {
    default: { bgcolor: '#D1D1D1', bordercolor: 'white' }
  }
  
  const backgroundColor = colors.default.bgcolor
  const borderColor = isRack ? '#292929' : 'transparent'
  
  return (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        borderRadius: markerProps.circle ? '50%' : '6px',
        backgroundColor: backgroundColor,
        border: isRack ? `2px solid ${borderColor}` : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      {isRack ? (
        <i 
          className="fa-solid fa-grid-dividers"
          style={{ 
            fontSize: `${size * 0.6}px`,
            fontWeight: '600',
            color: 'white'
          }} 
        />
      ) : markerProps.icon ? (
        <img 
          src={markerProps.icon}
          alt={type}
          style={{ 
            width: `${size * 0.6}px`,
            height: `${size * 0.6}px`,
            filter: colors.default.svgColorFilter || 'none'
          }}
        />
      ) : (
        <Box
          sx={{
            width: `${size * 0.6}px`,
            height: `${size * 0.6}px`,
            backgroundColor: '#666',
            borderRadius: '2px'
          }}
        />
      )}
    </Box>
  )
}

export default DeviceIcon